import { Checkbox as AntdCheckbox } from 'antd'

export const CheckboxGroup = (props: any) => <AntdCheckbox.Group {...props} />
